import axios from 'axios';
// config
import { HOST_API_KEY } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  users: {
    list: '/admin/user/list',
  },
  reward: {
    list: '/admin/reward/list',
    create: '/admin/reward/create',
  },
  quiz: {
    list: '/admin/quiz/list',
    create: '/admin/quiz/create',
    update: '/admin/quiz/update',
  },
  quizCategory: {
    list: '/admin/quiz-category/list',
    create: '/admin/quiz-category/create',
    update: '/admin/quiz-category/update',
  },
  public: {
    upload: '/admin/upload/file',
  },
  generalQuestion: {
    list: '/admin/general-question/list',
    create: '/admin/general-question/create',
    update: '/admin/general-question/update',
    upload: '/admin/general-question/generate',
  },
  questionCategory: {
    list: '/admin/question-category/list',
    create: '/admin/question-category/create',
    update: '/admin/question-category/update',
  },
  accountant: {
    transactionList: '/admin/transaction/list',
    generateExcel: '/admin/payment/list',
    uploadTransferExcel: '/admin/payment/upload-transfers',
  },
  shop: {
    create: '/admin/shop/create-item',
    update: '/admin/shop/update-item',
  },
};
